import React from 'react';

const HolidayInfoBanner = () => {
  const today = new Date();
  const month = today.getMonth();
  const date = today.getDate();
  const year = today.getFullYear();

  const isDecemberRange = (month === 11 && date >= 22);
  const isJanuaryRange = (month === 0 && date === 1);
  const isEaster = (year === 2025 && month === 3 && date >= 11 && date <= 21)
  const isSummer = (year === 2025 && month === 6 && date >= 12 && date <= 27)

  const isInDateRange = isDecemberRange || isJanuaryRange;
  return (
    <div>
      {isInDateRange && <div className="alert alert-info" role="alert"> I høytiden kan det forventes noe lengre tid før endringer blir publisert. Vi beklager dette. </div>}
      {isEaster && <div className="alert alert-info" role="alert"> God påske! I høytiden kan det ta litt tid før endringer blir publisert. Vi beklager dette. </div>}
      {isSummer && <div className="alert alert-info" role="alert"> På grunn av ferieavvikling i sommer kan det ta litt tid før endringer blir publisert. Vi beklager dette. </div>}
    </div>
  );
};

export default HolidayInfoBanner;